<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { defineComponent, onMounted, onBeforeUnmount } from 'vue';
import { throttle } from 'lodash'; // 导入 throttle 函数

export default defineComponent({
  name: 'App',
  setup() {
    let resizeObserver;

    // 定义 window resize 的处理函数，加入 throttle 限制
    const handleResize = throttle(() => {
      // 使用 requestAnimationFrame 延迟执行 DOM 操作，避免强制重排
      requestAnimationFrame(() => {
        // console.log('Window resized');
        // 在这里处理窗口尺寸变化的逻辑，比如调整某些元素大小等
      });
    }, 200);  // 每200ms触发一次

    // 组件挂载时，添加 ResizeObserver 监听
    onMounted(() => {
      // 监听特定的元素而不是整个页面，减少频繁的触发
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(document.querySelector('#app'));  // 只监听 #app 元素的尺寸变化
    });

    // 组件卸载时，移除 ResizeObserver
    onBeforeUnmount(() => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    });

    return {};
  }
});
</script>

<style>
body{
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f0f0f0;
}
</style>
